import { useMutation, useQueryClient } from "@tanstack/react-query";
import { StreamDestinationsFilters } from "@graylog/server-api";
import UserNotification from "util/UserNotification";
import { qualifyUrl } from "util/URLUtils";
import fetch from "logic/rest/FetchProvider";
import ApiRoutes from "routing/ApiRoutes";
const createStreamOutputRule = async ({ streamId, filterOutputRule }) => fetch("POST", qualifyUrl(ApiRoutes.StreamOutputFilterRuleApiController.create(streamId).url), filterOutputRule);
const updateStreamOutputRule = async ({ streamId, filterOutputRule }) => fetch(
  "PUT",
  qualifyUrl(ApiRoutes.StreamOutputFilterRuleApiController.update(streamId, filterOutputRule.id).url),
  filterOutputRule
);
const removeStreamOutputRule = async ({ streamId, filterId }) => StreamDestinationsFilters.deleteFilter(streamId, filterId);
const useStreamOutputRuleMutation = () => {
  const queryClient = useQueryClient();
  const invalidateStreamQueries = () => queryClient.invalidateQueries({
    queryKey: ["streams"]
  });
  const createMutation = useMutation({
    mutationFn: createStreamOutputRule,
    onError: (errorThrown) => {
      UserNotification.error(
        `Creating stream output filter rule failed with status: ${errorThrown}`,
        "Could not create stream output filter rule"
      );
    },
    onSuccess: () => {
      UserNotification.success("Stream Output filter rule has been successfully created.", "Success!");
      invalidateStreamQueries();
    }
  });
  const updateMutation = useMutation({
    mutationFn: updateStreamOutputRule,
    onError: (errorThrown) => {
      UserNotification.error(
        `Updating stream output filter rule failed with status: ${errorThrown}`,
        "Could not update stream output filter rule"
      );
    },
    onSuccess: () => {
      UserNotification.success("Stream Output filter rule has been successfully updated.", "Success!");
      invalidateStreamQueries();
    }
  });
  const removeMutation = useMutation({
    mutationFn: removeStreamOutputRule,
    onError: (errorThrown) => {
      UserNotification.error(
        `Deleting stream output filter rule failed with status: ${errorThrown}`,
        "Could not delete stream output filter rule"
      );
    },
    onSuccess: () => {
      UserNotification.success("Stream Output filter rule has been successfully removed.", "Success!");
      invalidateStreamQueries();
    }
  });
  return {
    createStreamOutputRule: createMutation.mutateAsync,
    updateStreamOutputRule: updateMutation.mutateAsync,
    removeStreamOutputRule: removeMutation.mutateAsync
  };
};
export default useStreamOutputRuleMutation;
